<template>
  <div class="addShop">
    <a-form
      layout="horizontal"
      :ref="torefs"
      :model="submitForm"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <df-titleline :title="'基本信息'"></df-titleline>

      <a-form-item label="商户名称" name="companyName">
        <a-input
          v-model:value="submitForm.companyName"
          placeholder="商户名称"
          style="width: 382px"
          :disabled="look"
        />
      </a-form-item>

      <a-form-item label="商户域名" name="region">
        <a-input
          v-model:value="submitForm.region"
          placeholder="商户名称"
          style="width: 382px"
          :disabled="look"
        >
          <template v-slot:addonAfter> .tianxiapiao.cn </template>
        </a-input>
      </a-form-item>

      <a-form-item label="商户logo" name="logo">
        <a-upload
          v-model:file-list="fileList"
          name="avatar"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          :before-upload="beforeUpload"
          @change="handleChange"
        >
          <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
          <div v-else>
            <loading-outlined v-if="loading"></loading-outlined>
            <plus-outlined v-else></plus-outlined>
            <div class="ant-upload-text">Upload</div>
          </div>
        </a-upload>
      </a-form-item>

      <df-titleline :title="'附加信息'"></df-titleline>



      <a-form-item label="业务类型" name="business">
        <a-checkbox-group
            style="margin-left: 10px"
            v-model:value="submitForm.business"
            :disabled="look"
            @change="showBuyModelChange"
        >
          <a-checkbox
              v-for="(value, key) in staticof.business"
              :key="key"
              :value="key"
          >
            {{ value }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>


      <a-form-item label="搜索供应" name="searchSupply"  v-show="showBuyModel">
        <a-radio-group
            style="margin-left: 10px"
            v-model:value="submitForm.searchSupply"
            :disabled="look"
            @change="searchChange"
        >
          <a-radio
              v-for="(value, key) in staticof.searchSupply"
              :key="key"
              :value="key"
          >
            {{ value }}
          </a-radio>
        </a-radio-group>
      </a-form-item>


      <a-form-item label="购票类型" name="buyModel"  id="buyModel" v-show="showBuyModel">
          <a-checkbox-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModel"
              :disabled="look"
              @change="showSupplierChange"
          >
            <a-checkbox
                v-for="(value, key) in staticof.buyModel"
                :key="key"
                :value="key"
            >
              {{ value }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-item>

<!--      不是供应分单的配置走这里-->
      <div id="isNotSplitSupplier" v-show="!isSplitSupplier">


        <a-form-item label="商旅出票供应"  name="agentBuyNormal"  id="agentBuyNormal" v-show="trainsSuppliers.agentBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.agentBuy.buyTypes.normal"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.agentBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="商旅改签供应"  name="agentBuyChange"  id="agentBuyChange" v-show="trainsSuppliers.agentBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.agentBuy.buyTypes.change"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.agentBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="商旅退票供应"  name="agentBuyRefund"  id="agentBuyRefund" v-show="trainsSuppliers.agentBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.agentBuy.buyTypes.refund"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.agentBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="自购出票供应"  name="selfBuyNormal"  id="selfBuyNormal" v-show="trainsSuppliers.selfBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.selfBuy.buyTypes.normal"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.selfBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="自购退票供应"  name="selfBuyRefund"  id="selfBuyRefund" v-show="trainsSuppliers.selfBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.selfBuy.buyTypes.refund"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.selfBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>



        <a-form-item label="自购改签供应"  name="selfBuyChange"  id="selfBuyChange" v-show="trainsSuppliers.selfBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.selfBuy.buyTypes.change"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.selfBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>




        <a-form-item label="现金票出票供应"  name="specialAgentBuyNormal"  id="specialAgentBuyNormal" v-show="trainsSuppliers.specialAgentBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialAgentBuy.buyTypes.normal"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.specialAgentBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="现金票改签供应"  name="specialAgentBuyChange"  id="specialAgentBuyChange" v-show="trainsSuppliers.specialAgentBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialAgentBuy.buyTypes.change"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.specialAgentBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="现金票退票供应"  name="specialAgentBuyRefund"  id="specialAgentBuyRefund" v-show="trainsSuppliers.specialAgentBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialAgentBuy.buyTypes.refund"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.specialAgentBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>








        <a-form-item label="电子票出票供应"  name="specialElectronicBuyNormal"  id="specialElectronicBuyNormal" v-show="trainsSuppliers.specialElectronicBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialElectronicBuy.buyTypes.normal"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.specialElectronicBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="电子票退票供应"  name="specialElectronicBuyRefund"  id="specialElectronicBuyRefund" v-show="trainsSuppliers.specialElectronicBuy.isShow && showBuyModel&& !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialElectronicBuy.buyTypes.refund"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.specialElectronicBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item label="电子票改签供应"  name="specialElectronicBuyChange"  id="specialElectronicBuyChange" v-show="trainsSuppliers.specialElectronicBuy.isShow && showBuyModel && !isSplitSupplier">
          <a-radio-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialElectronicBuy.buyTypes.change"
              :disabled="look"
          >
            <a-radio
                v-for="(value, key) in trainsSupplier.specialElectronicBuy"
                :key="key"
                :value="value.supplierId"
            >
              {{ value.supplierName}}
            </a-radio>
          </a-radio-group>
        </a-form-item>






      </div>

      <!--供应分单的权重配置走这里-->
      <div id="isSplitWeightSupplier" v-show="isSplitSupplier">

        <a-form-item label="商旅出票供应"  name="agentWeightBuyNormal"  id="agentWeightBuyNormal" v-show="trainsSuppliers.agentBuy.isShow && showBuyModel">
          
          <a-checkbox-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.agentBuy.supplierIds"
              :disabled="look"
              @change="changeAgentSplitSupplier"
          >
            <a-checkbox v-for="(value, key) in trainsSupplier.agentBuy" :value="value.id">
              {{ value.supplierName }}
            </a-checkbox>

          </a-checkbox-group>

          <div v-for="(value, key) in submitForm.buyModelSupplier.agentBuy.splitSuppliers">
            {{value.name}} 权重：
            <a-input
                v-model:value="value.weight"
                placeholder="商旅出票供应权重"
                style="width: 50px;"
                :disabled="look"
            />
          </div>
          
 
        </a-form-item>
        
        <a-form-item label="自购出票供应"  name="selfWeightBuyNormal"  id="selfWeightBuyNormal" v-show="trainsSuppliers.selfBuy.isShow && showBuyModel">
          
          <a-checkbox-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.selfBuy.supplierIds"
              :disabled="look"
              @change="changeselfSplitSupplier"
          >
            <a-checkbox v-for="(value, key) in trainsSupplier.selfBuy" :value="value.id">
              {{ value.supplierName }}
            </a-checkbox>

          </a-checkbox-group>

          <div v-for="(value, key) in submitForm.buyModelSupplier.selfBuy.splitSuppliers">
            {{value.name}} 权重：
            <a-input
                v-model:value="value.weight"
                placeholder="自购出票供应权重"
                style="width: 50px;"
                :disabled="look"
            />
          </div>
   
          
        </a-form-item>

        <a-form-item label="现金票出票供应"  name="specialWeightAgentBuyNormal"  id="specialWeightAgentBuyNormal" v-show="trainsSuppliers.specialAgentBuy.isShow && showBuyModel">
          
          <a-checkbox-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialAgentBuy.supplierIds"
              :disabled="look"
              @change="changeXjSplitSupplier"
          >
            <a-checkbox v-for="(value, key) in trainsSupplier.specialAgentBuy" :value="value.id">
              {{ value.supplierName }}
            </a-checkbox>

          </a-checkbox-group>

          <div v-for="(value, key) in submitForm.buyModelSupplier.specialAgentBuy.splitSuppliers">
            {{value.name}} 权重：
            <a-input
                v-model:value="value.weight"
                placeholder="现金票出票供应权重"
                style="width: 50px;"
                :disabled="look"
            />
          </div>

        </a-form-item>

        <a-form-item label="电子票出票供应"  name="specialWeightElectronicBuyNormal"  id="specialWeightElectronicBuyNormal" v-show="trainsSuppliers.specialElectronicBuy.isShow && showBuyModel">
          
          <a-checkbox-group
              style="margin-left: 10px"
              v-model:value="submitForm.buyModelSupplier.specialElectronicBuy.supplierIds"
              :disabled="look"
              @change="changeSplitSupplier"
          >
            <a-checkbox v-for="(value, key) in trainsSupplier.specialElectronicBuy" :value="value.id">
              {{ value.supplierName }}
            </a-checkbox>
            
          </a-checkbox-group>
          
          <div v-for="(value, key) in submitForm.buyModelSupplier.specialElectronicBuy.splitSuppliers">
            {{value.name}} 权重：
            <a-input
                v-model:value="value.weight"
                placeholder="电子票出票供应权重"
                style="width: 50px;"
                :disabled="look"
            />
          </div>
          
        </a-form-item>
        
      </div>



      <a-form-item label="预警金额" name="quota">
        <a-input
            v-model:value="submitForm.quota"
            placeholder="金额"
            style="width: 100px"
            :disabled="look"
            type="number"
        />
      </a-form-item>



      <a-form-item label="是否供应分单" name="main" v-if="!isButton">
        <a-radio-group
            v-model:value="submitForm.isSplit"
            button-style="solid"
            :default-value="0"
            @change="isSplitChange"
        >
          <a-radio-button :value="1"> 是</a-radio-button>
          <a-radio-button :value="0"> 否</a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="是否开具发票" name="main" v-if="!isButton">
        <a-radio-group
            v-model:value="submitForm.by1"
            button-style="solid"
            :default-value="0"
        >
          <a-radio-button :value="1"> 是</a-radio-button>
          <a-radio-button :value="0"> 否</a-radio-button>
        </a-radio-group>
      </a-form-item>


      <a-form-item label="开具发票供应"  name="invoiceSupply"  id="invoiceSupply" v-show="submitForm.by1 === 1">
        <a-radio-group
            style="margin-left: 10px"
            v-model:value="submitForm.by2"
            :disabled="look"
        >
          <a-radio
              v-for="(value, key) in trainsSupplier.invoiceSupplier"
              :key="key"
              :value="value.supplierId"
          >
            {{ value.supplierName}}
          </a-radio>
        </a-radio-group>
      </a-form-item>




      <a-form-item label="发送短信" name="main" v-if="!isButton">
            <a-radio-group
                    v-model:value="submitForm.smsSend"
                    button-style="solid"
                    :default-value="0"
                    @change="smsChange"
            >
                <a-radio-button :value="0"> 是</a-radio-button>
                <a-radio-button :value="1"> 否</a-radio-button>
            </a-radio-group>
        </a-form-item>

        <a-form-item label="指定发送手机号" name="sms">
            <a-input
                    v-model:value="submitForm.smsPhone"
                    placeholder="手机号"
                    style="width: 382px"
                    :disabled="look"
            />
        </a-form-item>

      <a-form-item label="乘客是否必填手机号" name="psgMain" >
        <a-radio-group
            v-model:value="submitForm.orderIsSendPhone"
            button-style="solid"
            :default-value="0"
            @change="psgPhoneChange"
        >
          <a-radio-button :value="0"> 是</a-radio-button>
          <a-radio-button :value="1"> 否</a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="查询外部客票状态" name="psgMain" >
        <a-radio-group
            v-model:value="submitForm.allowTicketStatus"
            button-style="solid"
            :default-value="1"
            @change="allowTicketChange"
        >
          <a-radio-button :value="0"> 是</a-radio-button>
          <a-radio-button :value="1"> 否</a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item
          v-show="showBuyModel"
          :wrapper-col="{ span: 14, offset: 2 }"
           v-for="(value, key) in services"
          :key="key"
      >
        <div>{{ staticof.buyModel[key] }}：</div>
        <a-table
            :columns="serviceColumns"
            bordered
            :data-source="value"
            :pagination="false"
            style="max-width: 1000px"
            :row-key="(r) => r.lid"
        >
          <template v-slot:normal="{ text, record }">
            <span>
              <a-input
                  v-model:value="record.normal"
                  style="width: 45%"
                  type="number"
                  :disabled="look"
              />
              元/张
            </span>
          </template>
          <template v-slot:change="{ text, record }">
            <span>
              <a-input
                  v-model:value="record.change"
                  style="width: 45%"
                  type="number"
                  :disabled="look"
              />
              元/张
            </span>
          </template>
          <template v-slot:refund="{ text, record }">
            <span>
              <a-input
                  v-model:value="record.refund"
                  style="width: 45%"
                  type="number"
                  :disabled="look"
              />
              元/张
            </span>
          </template>
        </a-table>

      </a-form-item>



      <a-form-item :wrapper-col="{ span: 14, offset: 2 }" v-if="!look">
        <a-button
          type="primary"
          size="large"
          @click="submitFormAction('submitForm')"
          :loading="loading"
          style="margin-top: 20px"
        >
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import shopApi from "@axios/shop";
import staticof from "@assets/static";
import supplierof from "@assets/supplier";
import {reactive, ref, nextTick, refs, watch, onMounted} from "vue";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import commonApi from "@axios/common";
import moment from "moment";
let VUE_APP_URL = process.env.VUE_APP_URL;

export default {
  name: "addShop",
  components: {
    LoadingOutlined,
    PlusOutlined,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    let itemrefs = [];
    const torefs = (el) => {
      itemrefs.push(el);
    };

    let settlements = ref({
      // train : [{
      //     businessModules : '10',
      //     beginRange : '',
      //     endRange : '',
      //     rateIncrease : '',
      //     priceIncrease : ''
      // }],
    });
    let services = ref({
      // train : [{
      //     businessModules : '10',
      //     beginRange : '',
      //     endRange : '',
      //     rateIncrease : '',
      //     priceIncrease : ''
      // }],
    });
      //按钮
      let isButton = ref(false);

    const servicesKeys = {
      10: "train",
      20: "hotel",
      30: "domesticTicket",
    };

    const settlementsKeys = {
      10: "train",
      20: "hotel",
      30: "domesticTicket",
      40: "internationalTicket",
      50: "taxi",
    };

    const settlementsValue = {
      train: "火车票",
      hotel: "酒店",
      domesticTicket: "国内机票",
      internationalTicket: "国际机票",
      taxi: "打车",
    };

    const columns = [
      {
        title: "数量",
        dataIndex: "number",
        width: 350,
        align: "center",
        slots: { customRender: "number" },
      },
      {
        title: "加价费/张/元",
        dataIndex: "premium",
        width: 200,
        align: "center",
        slots: { customRender: "premium" },
      },
      {
        title: "加价率",
        dataIndex: "rate",
        width: 200,
        align: "center",
        slots: { customRender: "rate" },
      },
      {
        title: "操作",
        align: "center",
        dataIndex: "operation",

        width: 200,

        slots: { customRender: "operation" },
      },
    ];

    const serviceColumns = [
      {
        title: "正常单服务费",
        dataIndex: "normal",
        width: 200,
        align: "center",
        slots: { customRender: "normal" },
      },
      {
        title: "退票单服务费",
        dataIndex: "refund",
        width: 200,
        align: "center",
        slots: { customRender: "refund" },
      },
      {
        title: "改签单服务费",
        dataIndex: "change",
        width: 200,
        align: "center",
        slots: { customRender: "change" },
      }
    ];

    const upload_headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };

    let loading = ref(false);

    const stateList = [
      {
        name: "未开始",
        val: 10,
      },
      {
        name: "签约中",
        val: 20,
      },
      {
        name: "合作中",
        val: 30,
      },
      {
        name: "已终结",
        val: 40,
      },
    ];

    let submitForm = ref({
          companyName: "",
          domain: "",
          region: "",
          logo: "",
          business: [],
          buyModel:[],
          buyModelSupplier:{
            agentBuy:{
              buyModel:'0',
              supplierId:-1,
              buyTypes:{
                normal: -1,
                change:-1,
                refund:-1
              },
              supplierIds:[],
              splitSuppliers: [
              ]
            },
            selfBuy:{
              buyModel:'1',
              supplierId:-1,
              buyTypes:{
                normal: -1,
                change:-1,
                refund:-1
              },
              supplierIds:[],
              splitSuppliers: [
              ]
            },
            specialAgentBuy:{
              buyModel:'2',
              supplierId:-1,
              buyTypes:{
                normal: -1,
                change:-1,
                refund:-1
              },
              supplierIds:[],
              splitSuppliers: [
              ]
              },
            specialElectronicBuy:{
              buyModel:'3',
              supplierId:-1,
              buyTypes:{
                normal: -1,
                change:-1,
                refund:-1
              },
              supplierIds:[],
              splitSuppliers: [
              ]
            }
          },
          searchSupply:'-1',
          isSplit: "0",
          smsSend: "0",
          smsPhone: "",
          smsInitPhone: "",
          supplierWeights:"",
          orderIsSendPhone: 1,
          allowTicketStatus: 1,
          by1: 0,
          by2: -1
      });

    //是否显示所有购票类型的供应信息
    let trainsSuppliers = ref({
      agentBuy: {buyModel:'0',isShow:false},
      selfBuy:{buyModel:'1',isShow:false},
      specialAgentBuy:{buyModel:'2',isShow:false},
      specialElectronicBuy:{buyModel:'3',isShow:false}
    });

    //是否显示所有购票类型的供应展示de信息
    let trainsSupplier = ref({
      agentBuy: [],
      selfBuy:[],
      specialAgentBuy:[],
      specialElectronicBuy:[],
      invoiceSupplier:[]
    });
    const  suppliers = sessionStorage.getItem("SupplierAll")
    const suppliersObj =  JSON.parse(suppliers)
    console.log("supplierssuppliers{}",suppliersObj)
    trainsSupplier = supplierof.categorizeSuppliers(suppliersObj);


    console.log("trainsSupplier categorize after {}",trainsSupplier)


    const rules = {
      companyName: [
        { required: true, message: "请输入企业名称", trigger: "blur" },
      ],
      region: [{ required: true, message: "请输入商户域名", trigger: "blur" }],
      // logo: [{ required: true, message: "请上传logo", trigger: "change" }],
    };
    let uploading = ref(false);
    const labelCol = { span: 2 };
    const wrapperCol = { span: 22 };
    let look = ref(false);
    let edit = ref(false);
    let showBuyModel = ref(false);

    let isSplitSupplier = ref(false);



    //methods
    const getDetail = () => {
      shopApi.getDistributor(route.query.id).then((res) => {
        submitForm.value.companyName = res.name;
        submitForm.value.region = res.region;
        submitForm.value.logo = res.logo;
        submitForm.value.business = res.businessModules.split(",");
        submitForm.value.buyModel = res.buyModel.split(",");
        submitForm.value.smsSend = res.smsSend;
        submitForm.value.smsPhone = res.smsPhone;
        submitForm.value.smsInitPhone = res.smsPhone;
        submitForm.value.quota = res.quota;
        submitForm.value.orderIsSendPhone = res.psgSendPhone !== undefined?res.psgSendPhone:1
        submitForm.value.isSplit = res.isSplit
        isSplitSupplier.value = res.isSplit == 1?true:false

        submitForm.value.searchSupply = res.queryModelSupplier+''
        submitForm.value.allowTicketStatus = parseInt(res.allowTicketStatus)
        submitForm.value.by1 = parseInt(res.by1)
        submitForm.value.by2 = parseInt(res.by2)


        services.value = res.services
        const  suppliers = res.buyModelSuppliers

        suppliers.forEach(supplier=>{
          const agentBuy = submitForm.value.buyModelSupplier.agentBuy
          const selfBuy = submitForm.value.buyModelSupplier.selfBuy
          const specialAgentBuy = submitForm.value.buyModelSupplier.specialAgentBuy
          const specialElectronicBuy = submitForm.value.buyModelSupplier.specialElectronicBuy


          if (supplier.buyTypes){
            supplier.buyTypes.normal = parseInt(supplier.buyTypes.normal)
            supplier.buyTypes.change = parseInt(supplier.buyTypes.change)
            supplier.buyTypes.refund = parseInt(supplier.buyTypes.refund)

            if (agentBuy.buyModel === supplier.buyModel){
              submitForm.value.buyModelSupplier.agentBuy.supplierId = supplier.supplierId
              submitForm.value.buyModelSupplier.agentBuy.buyTypes = supplier.buyTypes
              // 使用 map 方法提取 suplierId
              const suplierIds = supplier.splitSuppliers.map(supplier =>  parseInt(supplier.suplierId, 10));
              submitForm.value.buyModelSupplier.agentBuy.supplierIds =  suplierIds;
              submitForm.value.buyModelSupplier.agentBuy.splitSuppliers =  supplierof.findSuppliersById(supplier.splitSuppliers);
            }
            if (selfBuy.buyModel === supplier.buyModel){
              submitForm.value.buyModelSupplier.selfBuy.supplierId = supplier.supplierId
              submitForm.value.buyModelSupplier.selfBuy.buyTypes = supplier.buyTypes

              // 使用 map 方法提取 suplierId
              const suplierIds = supplier.splitSuppliers.map(supplier =>  parseInt(supplier.suplierId, 10));
              submitForm.value.buyModelSupplier.selfBuy.supplierIds =  suplierIds;
              submitForm.value.buyModelSupplier.selfBuy.splitSuppliers =  supplierof.findSuppliersById(supplier.splitSuppliers);
            }
            if (specialAgentBuy.buyModel === supplier.buyModel){
              submitForm.value.buyModelSupplier.specialAgentBuy.supplierId = supplier.supplierId
              submitForm.value.buyModelSupplier.specialAgentBuy.buyTypes = supplier.buyTypes

              // 使用 map 方法提取 suplierId
              const suplierIds = supplier.splitSuppliers.map(supplier =>  parseInt(supplier.suplierId, 10));
              submitForm.value.buyModelSupplier.specialAgentBuy.supplierIds =  suplierIds;
              submitForm.value.buyModelSupplier.specialAgentBuy.splitSuppliers =  supplierof.findSuppliersById(supplier.splitSuppliers);
            }
            if (specialElectronicBuy.buyModel === supplier.buyModel){
              submitForm.value.buyModelSupplier.specialElectronicBuy.supplierId = supplier.supplierId
              submitForm.value.buyModelSupplier.specialElectronicBuy.buyTypes = supplier.buyTypes

              // 使用 map 方法提取 suplierId
              const suplierIds = supplier.splitSuppliers.map(supplier =>  parseInt(supplier.suplierId, 10));
              
              
              submitForm.value.buyModelSupplier.specialElectronicBuy.supplierIds =  suplierIds;
              submitForm.value.buyModelSupplier.specialElectronicBuy.splitSuppliers =  supplierof.findSuppliersById(supplier.splitSuppliers);
            }
          }

        })

        console.log("submitForm{}",submitForm.value)

        let train = submitForm.value.business.find(trains=>trains === "10")
        showBuyModel.value = !!train;

        isShowSupplier(submitForm.value.buyModel);

        for (var i in res.settlements) {
          res.settlements[i].forEach((ele, index) => {
            delete ele.adminId;
            delete ele.createTime;
            delete ele.updateTime;
            delete ele.id;
            delete ele.distributorId;
            ele.lid = ele.businessModules + "_" + index;
            if (ele.endRange == 99999999) {
              ele.endRange = "";
            }
          });
          if (!res.settlements[i].length) {
            delete res.settlements[i];
          }
        }
        //避开watch的异步
        nextTick(() => {
          settlements.value = res.settlements;
         // console.log(res.settlements);
        });
      });
    };


    //切换sms设置类型
    const smsChange = (e) => {
        typeChange(e.target.value);
    };

    const isSplitChange  = (e) => {
      typeSplitChange(e.target.value);
    };

    const psgPhoneChange = (e) => {
      console.log("e",e)
      console.log("submitForm.orderIsSendPhone",submitForm.value.orderIsSendPhone)
    }

    const allowTicketChange = (e) => {
      console.log("e",e)
      console.log("submitForm.allowTicketStatus",submitForm.value.allowTicketStatus)
    }

    //切换（M目录 C菜单 F按钮）
    const typeChange = (menuType) => {
        console.log("切换短信配置 ： " + menuType + ", 当前值 ： " + submitForm.value.smsInitPhone);
        if (menuType == "1") {
            submitForm.value.smsPhone = "";
        }
        if (menuType == "0") {
            submitForm.value.smsPhone = submitForm.value.smsInitPhone;
        }
    };

    const typeSplitChange = (menuType) => {
      console.log("切换是否开启供应分单配置 ： " + menuType );
      isSplitSupplier.value = (menuType==1?true:false);
      console.log("切换是否开启供应分单配置 isSplitSupplier ： " + isSplitSupplier );
      //showSupplierChange()
    };

    //creat 逻辑
    const type = route.query.type;

    //console.log(type);

    if (type === "look") look.value = true;
    if (type === "edit") edit.value = true;
    if (type) getDetail();

    const validation = () => {
      let tag = true;
      if (!submitForm.value.business.length) {
        message.error("请选择具体业务");
        return false;
      }
      //结尾是否是无尽 开头是否是小于等于1  是否是首尾相连
      Object.keys(settlements.value).forEach((element) => {
        console.log(settlements.value);
        let num = 0; //记录上一个结尾
        try {
          settlements.value[element].forEach((data, index) => {
            // 开头是否是小于等于1
            console.log(data.beginRange - 1);
            console.log(num);
          });
        } catch (e) {
          tag = false;
        }
      });

      return tag;
    };

    const delList = (key, index, row) => {
      settlements.value[key].splice(index, 1);
    };
    const addList = (key, row) => {
      settlements.value[key].push({
        businessModules: row.businessModules,
        beginRange: "",
        endRange: "",
        rateInfo: "",
        priceIncrease: "",
        lid: row.lid + "_" + row.businessModules,
      });
    };

    const submitFormAction = (form) => {
      itemrefs[0]
        .validate()
        .then(() => {
          //console.log("submitForm.value",submitForm.value);
          //验证规则是否合法
          let rules = validation();
          console.log(rules);
          if (!rules) return;
          //整理参数
          let params = {
            name: submitForm.value.companyName,
            region: submitForm.value.region,
            settlements: settlements.value,
            businessModules: submitForm.value.business.join(","),
            buyModel: submitForm.value.buyModel.join(","),
            services: services.value,
            isSplit:submitForm.value.isSplit,
            smsSend: submitForm.value.smsSend,
            smsPhone: submitForm.value.smsPhone,
            quota: submitForm.value.quota,
            queryModelSupplier:submitForm.value.searchSupply,
            psgSendPhone:submitForm.value.orderIsSendPhone,
            allowTicketStatus:submitForm.value.allowTicketStatus,
            by1:submitForm.value.by1,
            by2:submitForm.value.by2
          };
          //渠道购票模式传递的对应的供应信息
          params.buyModelSuppliers= []
          params.buyModelSuppliers.push(submitForm.value.buyModelSupplier.agentBuy)
          params.buyModelSuppliers.push(submitForm.value.buyModelSupplier.selfBuy)
          params.buyModelSuppliers.push(submitForm.value.buyModelSupplier.specialAgentBuy)
          params.buyModelSuppliers.push(submitForm.value.buyModelSupplier.specialElectronicBuy)
          params.buyModelSuppliers= JSON.stringify(params.buyModelSuppliers)

          loading.value = true;
          if (edit.value) {
            params.lid = route.query.id;
            shopApi
              .editDistributor(params)
              .then((r) => {
                router.push({
                  name: "channelShopIndex",
                });
                loading.value = false;
                message.success("修改成功")
              })
              .catch(() => {
                loading.value = false;
              });
          } else {
            shopApi
              .addDistributor(params)
              .then((r) => {
                router.push({
                  name: "channelShopIndex",
                });
                loading.value = false;
                message.success("新增渠道成功")
              })
              .catch((e) => {
                loading.value = false;
              });
          }
        })
        .catch((err) => {
          loading.value = false;
        });
    };

    let oldFrom = 0;

    watch(submitForm.value, (val, pre) => {

      if (oldFrom !== val.business.length) {
        let obj = {};
        val.business.forEach((element, index) => {
          if (settlements.value[settlementsKeys[element]]) {
            obj[settlementsKeys[element]] =
              settlements.value[settlementsKeys[element]];
          } else {
            obj[settlementsKeys[element]] = [
              {
                businessModules: element,
                beginRange: "",
                endRange: "",
                rateInfo: "",
                priceIncrease: "",
                lid: element + "_" + index,
              },
            ];
          }
        });
        settlements.value = obj;
      }
      oldFrom = val.business.length;

      let serverceObj = {};
      val.buyModel.forEach((element,index) => {

        if (services.value[element]){
          serverceObj[element] = services.value[element]
        }else {
          serverceObj[element] = [{
            normal:0,
            refund:0,
            change:0
          }]
        }
      })
      services.value = serverceObj

    });

    const beforeUpload = (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("请上传图片格式");
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        message.error("不能超过 20MB!");
      }

      return isJpgOrPng && isLt2M;
    };

    const customRequest = (file) => {
      let formData = new FormData();
      //多个文件上传
      formData.append("file", file.file); // 文件对象

      commonApi.upload(formData).then((res) => {
        submitForm.value.logo = res[0].filePath;
      });
    };

    const showBuyModelChange =  (model) => {
      let train = model.find(trains=>trains === "10")
      showBuyModel.value = !!train;

    }

    const showSupplierChange = () => {
      const models = submitForm.value.buyModel;
      isShowSupplier(models)
    }

    //显示购票模式下含有的供应
    const isShowSupplier = (models) => {
      if (models.includes(trainsSuppliers.value.selfBuy.buyModel)) {
        trainsSuppliers.value.selfBuy.isShow = true;
      }else {
        trainsSuppliers.value.selfBuy.isShow = false;
      }

      if (models.includes(trainsSuppliers.value.agentBuy.buyModel)){
        trainsSuppliers.value.agentBuy.isShow = true;
      }else {
        trainsSuppliers.value.agentBuy.isShow = false;
      }

      if (models.includes(trainsSuppliers.value.specialAgentBuy.buyModel)){
        trainsSuppliers.value.specialAgentBuy.isShow = true;
      }else {
        trainsSuppliers.value.specialAgentBuy.isShow = false;
      }

      if (models.includes(trainsSuppliers.value.specialElectronicBuy.buyModel)){
        trainsSuppliers.value.specialElectronicBuy.isShow = true;
      }else {
        trainsSuppliers.value.specialElectronicBuy.isShow = false;
      }
    }



    //切换电子票分单供应
    const changeSplitSupplier = () => {
      const eleSupplierIds = submitForm.value.buyModelSupplier.specialElectronicBuy.supplierIds;
      console.log("电子票分单供应 eleSupplierIds:{}",eleSupplierIds)
      
      //原先已经选择供应id
      var oriSuppliers = submitForm.value.buyModelSupplier.specialElectronicBuy.splitSuppliers
      console.log("已经选择供应id oriSuppliers:{}",oriSuppliers)
      // 使用 reduce 将数组转换为 Map
      const supplierMap = oriSuppliers.reduce((acc, supplier) => {
        acc.set(parseInt(supplier.id), supplier);
        return acc;
      }, new Map());
      
      //选择新增权重
      for (let i = 0; i < eleSupplierIds.length; i++) {
        var theSupplier = supplierof.findSupplierById(eleSupplierIds[i]);
        theSupplier.weight = 0
        theSupplier.suplierId = theSupplier.id
        theSupplier.suplierInfo = theSupplier.name

        console.log("supplierMap.get(theSupplier.id):{}",supplierMap.get(theSupplier.id))
        if (!supplierMap.get(theSupplier.id)){
          oriSuppliers.push(theSupplier)
        }
      }
      //如果旧选中框不在新选中框中，则删除
      oriSuppliers = supplierof.findSuppliersByIds(oriSuppliers,eleSupplierIds)
      
      submitForm.value.buyModelSupplier.specialElectronicBuy.splitSuppliers = oriSuppliers
  
      console.log("电子票分单供应 submitForm.value.buyModelSupplier.specialElectronicBuy.splitSuppliers {}",submitForm.value.buyModelSupplier.specialElectronicBuy.splitSuppliers)
    }


    //切换现金票分单供应
    const changeXjSplitSupplier = () => {
      const xjSupplierIds = submitForm.value.buyModelSupplier.specialAgentBuy.supplierIds;
      console.log("现金票分单 specialAgentBuy SupplierIds:{}",xjSupplierIds)
      var suppliersWeight = []
      for (let i = 0; i < xjSupplierIds.length; i++) {
        var theSupplier = supplierof.findSupplierById(xjSupplierIds[i]);
        theSupplier.weight = 0
        theSupplier.suplierId = theSupplier.id
        theSupplier.suplierInfo = theSupplier.name
        suppliersWeight.push(theSupplier)
      }
      submitForm.value.buyModelSupplier.specialAgentBuy.splitSuppliers = suppliersWeight
      console.log("现金票分单 specialAgentBuy suppliersWeight {}",suppliersWeight)
      console.log("现金票分单 submitForm.value.buyModelSupplier.specialAgentBuy.splitSuppliers {}",submitForm.value.buyModelSupplier.specialAgentBuy.splitSuppliers)
    }


    //切换自购分单供应
    const changeselfSplitSupplier = () => {
      const xjSupplierIds = submitForm.value.buyModelSupplier.selfBuy.supplierIds;
      console.log("自购分单 selfBuy SupplierIds:{}",xjSupplierIds)
      var suppliersWeight = []
      for (let i = 0; i < xjSupplierIds.length; i++) {
        var theSupplier = supplierof.findSupplierById(xjSupplierIds[i]);
        theSupplier.weight = 0
        theSupplier.suplierId = theSupplier.id
        theSupplier.suplierInfo = theSupplier.name
        suppliersWeight.push(theSupplier)
      }
      submitForm.value.buyModelSupplier.selfBuy.splitSuppliers = suppliersWeight
      console.log("自购分单 selfBuy suppliersWeight {}",suppliersWeight)
      console.log("自购分单 submitForm.value.buyModelSupplier.selfBuy.splitSuppliers {}",submitForm.value.buyModelSupplier.selfBuy.splitSuppliers)
    }

    //切换商旅分单供应
    const changeAgentSplitSupplier = () => {
      const xjSupplierIds = submitForm.value.buyModelSupplier.agentBuy.supplierIds;
      console.log("切换商旅分单供应 agentBuy SupplierIds:{}",xjSupplierIds)
      var suppliersWeight = []
      for (let i = 0; i < xjSupplierIds.length; i++) {
        var theSupplier = supplierof.findSupplierById(xjSupplierIds[i]);
        theSupplier.weight = 0
        theSupplier.suplierId = theSupplier.id
        theSupplier.suplierInfo = theSupplier.name
        suppliersWeight.push(theSupplier)
      }
      submitForm.value.buyModelSupplier.agentBuy.splitSuppliers = suppliersWeight
      console.log("切换商旅分单供应 sl suppliersWeight {}",suppliersWeight)
      console.log("切换商旅分单供应 sl.value.buyModelSupplier.agentBuy.splitSuppliers {}",submitForm.value.buyModelSupplier.agentBuy.splitSuppliers)
    }





    const searchChange = () => {
      console.log("submitForm.value.searchSupply{}",submitForm.value.searchSupply)
    }

    return {
      searchChange,
      showSupplierChange,
      changeSplitSupplier,
      changeXjSplitSupplier,
      changeselfSplitSupplier,
      changeAgentSplitSupplier,
      trainsSuppliers,
      trainsSupplier,
      supplierof,
      showBuyModelChange,
      customRequest,
      beforeUpload,
      uploading,
      torefs,
      staticof,
      settlements,
      settlementsKeys,
      settlementsValue,
      services,
      columns,
      serviceColumns,
      VUE_APP_URL,
      upload_headers,
      loading,
      stateList,
      submitForm,
      rules,
      labelCol,
      wrapperCol,
      look,
      showBuyModel,
      edit,
      isSplitSupplier,
      delList,
      addList,
      submitFormAction,
      baseuri: process.env.VUE_APP_IMG_BASE,
      isButton,
      moment,
      smsChange,
      isSplitChange,
      psgPhoneChange,
      allowTicketChange

    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.upload_images {
  width: 100px;
}


</style>


